module.exports = __webpack_public_path__ + "img/sz.ab745fb8.jpg";